import axios from 'axios';
import { concat, contains, compose, filter, pluck, prop, toLower, sortBy } from 'ramda';

import * as urls from 'constants/urls';

const uniqMerge = (first, second) => {
    const values = pluck('id', first);
    const filtered = filter(item => !contains(item.id, values), second);
    return concat(first, filtered);
};
const sortByName = sortBy(compose(toLower, prop('firstName')));

export const getResponsibleUsersDictHandler = () => axios.get(urls.RESPONSIBLE_USERS_DICT.stringify());
export const getResponsibleUsersHandler = () => axios.get(urls.RESPONSIBLE_USERS.stringify());

export const getPortfolioUsersHandler = () => {
    return axios.all([
        getResponsibleUsersHandler(),
        axios.get(urls.COEXECUTIVE_USERS.stringify())
    ]).then(axios.spread((responsible = [], coexecutive = []) => {
        return sortByName(uniqMerge(responsible, coexecutive));
    }));
};

export const getOrganizationsHandler = () => axios.get(urls.ORGANIZATIONS.stringify());
export const getDepartmentHandler = ({ payload: { company = 1 } }) => axios.get(urls.DEPARTMENT.stringify({ company }));
export const getLegalOrganizationsHandler = () => axios.get(urls.LEGAL_ORGANIZATIONS.stringify());
export const getLegalDepartmentHandler = ({ payload: { company = 1 } }) => axios.get(urls.LEGAL_DEPARTMENT.stringify({ company }));
export const getLegalDepartmentCellsHandler = ({ payload: { department = 0 } }) => axios.get(urls.LEGAL_DEPARTMENT_CELLS.stringify({ department }));
export const getTownsHandler = ({ payload }) => {
    return axios.get(urls.TOWNS.stringify(), { params: { URLEncESSFilter: payload.value }});
};
export const getReplacingHandler = ({ payload }) => {
    const { organizationId, departmentId } = payload;
    return axios.get(urls.REPLACING.stringify({ organizationId, 'departmentId': departmentId || 0 }));
};
export const getEmployeeHandler = ({ payload: { organizationId } }) => axios.get(urls.EMPLOYEE.stringify({ organizationId }));
export const getAvailableEventsHandler = ({ payload: params }) => axios.get(urls.EVENT_TYPES.stringify(), { params });
export const getEventDictionariesHandler = ({ payload : project }) => axios.get(urls.EVENT_DICTIONARIES.stringify(), { params: { project } });

export const getDictionaryHandler = ({ payload }) => payload ? axios.get(payload) : null;

export const getPersonStateHandler = async ({ payload: { personId, projectId } }) => {
    const menu = await axios.get(urls.PERSON_STATE.stringify({ projectId, personId }));
    let who;
    try {
        who = await axios.get(urls.PERSON_WHO_STATE.stringify({ projectId, personId }));
    } catch {
        who = {}
    }
    return {
        ...menu,
        who: who.id,
    };
};
export const putPersonStateHandler = ({ payload }) => axios.put(urls.CHANGE_PERSON_STATE.stringify(), payload);

export const getMassStagesHandler = ({ payload }) => axios.get(urls.MASS_STAGES.stringify({ id: payload }));

export const postMassStageHandler = ({ payload }) => axios.post(urls.MASS_STAGE.stringify(), payload);
export const postMassStageMenuHandler = ({ payload }) => axios.post(urls.MASS_STAGE_MENU.stringify(), payload);

export const getMetroDepartmentsHandler = ({ payload }) => axios.get(urls.METRO_DEPARTMENTS.stringify(), { params: payload });
export const getMetroDepartmentChildrenHandler = ({ payload }) => axios.get(urls.METRO_DEPARTMENT_CHILDREN.stringify(), { params: payload });
